import styled from 'styled-components';

export default styled.div `
  width: 380px;
  height: 468px;
  margin: 0 auto;
  background-color: #a7b5ad;
  padding: 8px;
  border: 2px solid #141414;
`;
